/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Create_Folder_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter folder name" |
*
* @param {Explorer_Nav_Create_Folder_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_create_folder_placeholder = /** @type {((inputs?: Explorer_Nav_Create_Folder_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Create_Folder_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entrez le nom du dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordnernamen eingeben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci il nome della cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите название папки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca el nombre de la carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输入文件夹名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダ名を入力")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर का नाम दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Digite o nome da pasta")
	return /** @type {LocalizedString} */ ("Enter folder name")
});